import React from 'react';
import { useFormikContext } from 'formik';

const LikertScalePreview = ({ question, fieldName, sendSurvey, outOfDate }) => {
  const { setFieldValue, values } = useFormikContext();
  const disabled = !sendSurvey || outOfDate;

  const choices = (question.questionChoicesAttributes || [])
    .filter(c => !c._destroy)
    .sort((a, b) => a.position - b.position);

  const currentValue = values?.employeeSurvey?.employeeQuestionChoicesAttributes?.find?.(
    eqc => eqc?.questionId === question.id
  )?.questionChoiceId;

  const handleSelect = choice => {
    if (disabled) return;
    setFieldValue(`${fieldName}[questionChoiceId]`, choice.id || choice.position);
  };

  return (
    <div className="eval-likert-preview-row">
      {choices.map(choice => {
        const choiceKey = choice.id || choice.position;
        const isSelected = String(currentValue) === String(choiceKey);
        const className = ['eval-likert-preview-item', isSelected ? 'selected' : '', disabled ? 'disabled' : '']
          .filter(Boolean)
          .join(' ');

        return (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <div key={choiceKey} className={className} onClick={() => handleSelect(choice)}>
            {choice.label || `Opción ${choice.position}`}
          </div>
        );
      })}
    </div>
  );
};

export default LikertScalePreview;
